import React, {Component} from 'react';

import {withRouter} from 'react-router-dom';
import REST from '../Shared/REST';
import Helpers from "../Shared/Helpers";
import queryString from 'query-string';

import "./KSGrading/style/style.css";
import HeaderComponent from "../Shared/Header";
import connect from "react-redux/es/connect/connect";
import logo_wordmark2 from "../assets/images/logo_wordmark2.png";
import DialogBox from "../Shared/DialogBox";
import DeleteDialogBox from "../Shared/DeleteDialogBox";
import DropDownNotifications from "../Shared/DropDownNotifications";
import ReportBugForm from "../ModalFormComponents/ReportBugForm";
import {updateStudent} from "./actions";
import {TRACKING} from "../Shared/DataTrackingPoints";
import {Modal} from "react-bootstrap";

class WordMark2Grading extends Component {

    constructor(props) {
        super(props);
        this.state = {
            bestScores: null,
            gradeStart: null,
            storyPrompt1:'',
            storyPrompt2:'',
            storyStarter: {},
            studentResponse: '',
            score: 0,
            correct: 0,
            incorrect: 0,
            paragraphs: [],
            wordIndex:0,
            highlighted: -1,
            timer: null,
            progressBar: {
                width: null
            },
            modalDialog:false,
            responseContent:'',
            modalDialogDelete: false,
            modalDialogNote: false,
            noteContent:'',
            handleNext: false,
            taskID:null,
            sessionData: {
                testId: 0,
                gradingData: "",
                gradingTime: 0,
                numberCorrect: 0,
                numberIncorrect: 0
            },
            analytics: {
                type: null,
                metadata: null,
            },
            spelling: []
        };

        this.startGrading = this.startGrading.bind(this);
        this.submitWordMark2SessionGrade = this.submitWordMark2SessionGrade.bind(this);
        this.initializeData = this.initializeData.bind(this);
        this.calculateScore = this.calculateScore.bind(this);
        this.mouseClick = this.mouseClick.bind(this);
        this.wrongTickMark = this.wrongTickMark.bind(this);
        this.correctTickMark = this.correctTickMark.bind(this);
        this.showCurrentMark = this.showCurrentMark.bind(this);
        this.fillWithChecks = this.fillWithChecks.bind(this);
        this.clearCounters = this.clearCounters.bind(this);
        this.keyDownListener = this.keypress.bind(this);
        this.highlightLeft = this.highlightLeft.bind(this);
        this.highlightRight = this.highlightRight.bind(this);
        this.deleteScore = this.deleteScore.bind(this);
        this.handleTakeANote = this.handleTakeANote.bind(this);
        this.saveNote = this.saveNote.bind(this);
        this.deleteNote = this.deleteNote.bind(this);
        this.handleNoteClose = this.handleNoteClose.bind(this);
        this.handleNoteContentChange = this.handleNoteContentChange.bind(this);
        this.checkSpelling = this.checkSpelling.bind(this);
        this.handleStudentClick = this.handleStudentClick.bind(this);
        this.handleNextTask = this.handleNextTask.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
        this.handleSurveyBack = this.handleSurveyBack.bind(this);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.keyDownListener);
    }

    async componentDidMount() {
        Helpers.authorize(this);
        const parsed = queryString.parse(this.props.location.search);
        await this.setState({
            testId: parsed.testId,
            gradeStart: Date.now(),
            analytics:{
                type: TRACKING.WM_SCORE_VIEW,
                metadata:{testId:parsed.testId}
            }
        });
        this.startGrading(parsed.testId);
        REST.getStudentNotifications().then(res => {
            for(let i = 0; i < res.body.length; i++){
                for(let j=0; j<res.body[i].apps.wordMark2Scores.length; j++){
                    let wordMark2Scores = res.body[i].apps.wordMark2Scores[j];
                    if (wordMark2Scores && wordMark2Scores.userId === this.props.lastStudent.user.id && wordMark2Scores.id != parsed.testId) {
                        this.setState({
                            handleNext: true,
                            taskID: wordMark2Scores.id
                        });
                    }
                }
            }
        });
        this.handleAnalytics();
        document.addEventListener("keydown", this.keyDownListener);
    };

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleNextTask(){
        window.location.href = '/teacher/apps/wm2-grading?testId=' + this.state.taskID;
    }

    submitWordMark2SessionGrade(event) {
        let gradingData = "";
        for (let i = 0; i < this.state.paragraphs.length; i++) {
            if (this.state.paragraphs[i].alt === "") {
                gradingData = gradingData + "0"
            } else if (this.state.paragraphs[i].alt === "wrong") {
                gradingData = gradingData + "2"
            } else {
                gradingData = gradingData + "1"
            }
            if (i !== this.state.paragraphs.length - 1) {
                gradingData = gradingData + ","
            }
        }
        this.setState({
            sessionData: {
                testId: this.state.testId,
                gradingData: gradingData,
                gradingTime: Math.ceil((Date.now() - this.state.gradeStart) / 1000),
                numberCorrect: this.state.correct,
                numberIncorrect: this.state.incorrect
            }
        }, () => {
            console.log("Submitting session data: ", this.state.sessionData);
            REST.gradeWordMark2Session(this.state.sessionData).then((res) => {
                if (res.success) {
                    this.setState({
                        modalDialog: true,
                        responseContent:'Score task saved.',
                        analytics: {
                            type: TRACKING.WM_SCORE_SAVE,
                            metadata: {testId: this.state.testId}
                        }
                    });
                    this.handleAnalytics();
                    setTimeout(()=>{this.setState({modalDialog:false})},3500);
                } else {
                    this.setState({
                        modalDialog: true,
                        responseContent:'Grading Failed to update'

                    });
                    setTimeout(()=>{this.setState({modalDialog:false})},3500);
                }
            }).catch(err => {
                console.log(err);
                this.setState({
                    modalDialog: true,
                    responseContent:'Grading Failed to update'

                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            });
        });
    };

    // functions to add tick icons
    async wrongTickMark(index, current) {
        if(current) {
            this.state.paragraphs[index].src = require("./KSGrading/style/images_WordMark2/current_wrong.png");
        }else{
            this.state.paragraphs[index].src = require("./KSGrading/style/images_WordMark2/wrong.png");
        }
        this.state.paragraphs[index].alt = "wrong";
        this.state.incorrect = this.state.incorrect + 1;
        await this.forceUpdate();
    };

    async correctTickMark(index, current) {
        if(current) {
            this.state.paragraphs[index].src = require("./KSGrading/style/images_WordMark2/current_correct.png");
        }else{
            this.state.paragraphs[index].src = require("./KSGrading/style/images_WordMark2/correct.png");
        }
        this.state.paragraphs[index].alt = "correct";
        this.state.correct = this.state.correct + 1;
        await this.forceUpdate();
    };

    async showCurrentMark(index, current){
        let imgAlt = this.state.paragraphs[index].alt;
        console.log('showCurrentMark');
        console.log(index);
        console.log(this.state.paragraphs[index].alt);
        console.log(current);
        if (imgAlt === "correct") {
            if(current) {
                this.state.paragraphs[index].src = require("./KSGrading/style/images_WordMark2/current_correct.png");
            }else{
                this.state.paragraphs[index].src = require("./KSGrading/style/images_WordMark2/correct.png");
            }
        }
        else if (imgAlt === "wrong") {
            if(current) {
                this.state.paragraphs[index].src = require("./KSGrading/style/images_WordMark2/current_wrong.png");
            }else{
                this.state.paragraphs[index].src = require("./KSGrading/style/images_WordMark2/wrong.png");
            }
        }else{
            if(current) {
                this.state.paragraphs[index].src = require("./KSGrading/style/images_WordMark2/current_blank.png");
            }else{
                this.state.paragraphs[index].src = "";
            }
        }
        await this.forceUpdate();
        return imgAlt;
    }

    async removeMark(index) {
        let imgAlt = this.state.paragraphs[index].alt;
        if (imgAlt === "correct") {
            this.state.correct = this.state.correct - 1;
            this.state.paragraphs[index].src = "";
            this.state.paragraphs[index].alt = "";
        }
        else if (imgAlt === "wrong") {
            this.state.incorrect = this.state.incorrect - 1;
            this.state.paragraphs[index].src = "";
            this.state.paragraphs[index].alt = "";
        }
        await this.forceUpdate();
        return imgAlt;
    };

    async swapMark(index) {
        let oldImgAlt = this.removeMark(index);
        if (oldImgAlt === "correct") {
            await this.wrongTickMark(index, false);
        }
        else if (oldImgAlt === "wrong") {
            await this.correctTickMark(index, false);
        }
    };

    async calculateScore() {
        let newScore = parseInt(this.state.correct, 10) - parseInt(this.state.incorrect, 10);
        if (newScore <= 0) {
            this.state.score = 0;
        }
        else {
            this.state.score = newScore;
        }
        await this.forceUpdate();
    };

    clearCounters() {
        //$("#data img").remove();
        this.setState({
            endIndex: 0,
            score: 0,
            correct: 0,
            incorrect: 0,
            highlighted: -1
        });
        this.state.paragraphs.map((paragraph, i) => {
            paragraph.src = "";
            paragraph.alt = "";
            paragraph.highlighted = false;
        });
        this.forceUpdate();
    };

    async mouseClick(i,e) {

        let c = 0;
        for(let p of this.state.paragraphs){
            p.highlighted = c === i;
            this.showCurrentMark(c, false);
            c++;
        }
        await this.forceUpdate();

        if(e){
            await this.removeMark(i);
            await this.calculateScore();
        }
        await this.highlightLeft(i);
    };

    fillWithChecks() {
        let imgAlt;
        for (let i = 0; i < this.state.endIndex; i++) {
            imgAlt = this.state.paragraphs[i].alt;
            if (imgAlt === "") {
                this.correctTickMark(i);
            }
        }
        this.calculateScore();
    };

    async checkSpelling(){
        let newParagraphs = [];
        for (let i = 0; i < this.state.paragraphs.length; i++) {
            let test = this.state.spelling.includes(this.state.paragraphs[i].word);
            this.state.paragraphs[i].spellCheck = test;
            newParagraphs.push(this.state.paragraphs[i]);
        }
        this.setState({
            paragraphs:newParagraphs
        });
    }

    async initializeData() {
        let csv = this.state.sessionData.gradingData;
        let tickArr = [];
        if (csv) {
            tickArr = csv.split(",");
        }
        let text = this.state.studentResponse;

        // Trim out new lines
        text = text.trim();

        // Add space for certain characters and trim out new lines
        text = text.replace(/\./g, " . ").replace(/\?/g, " ?").replace(/!/g, " !").trim();

        // Convert text to word array by splitting at spaces
        text = text.replace(/\s+([])\s+|\s+([])|([])+\s|([])/gm," $1$2$3$4 ");
        if(text[text.length-1]===" "){
            text = text.substr(0,text.length-1);
        }
        let wordArr = text.split(/\s+/);
        // Ensures the tick array has its
        // length equal to the word count
        while (tickArr.length > wordArr.length) {
            tickArr.pop();
        }
        while (tickArr.length < wordArr.length) {
            tickArr.push("0");
        }

        // Create elements for each word and appends to container in order
        for (let i = 0; i < wordArr.length; i++) {
            let word = wordArr[i];

            let newPar = {
                index: i,
                word: word,
                src: "",
                alt: "",
                highlighted: false
            };
            await this.setState({
                paragraphs: [...this.state.paragraphs, newPar]
            });
            if (tickArr[i] === "1") {
                await this.correctTickMark(i, false);
                this.state.endIndex = i;
            }
            else if (tickArr[i] === "2") {
                await this.wrongTickMark(i, false);
                this.state.endIndex = i;
            }
        }
        // Calculates initial score
        this.forceUpdate();
        this.calculateScore();
        // Display the total word count
        const regxPunctuation = /[]/g
        this.state.totalWords = wordArr.filter(function(value) { return !(value).match(regxPunctuation)  }).length;
        await this.forceUpdate();
        this.mouseClick(0);
    }

    async playSound(type){
        if (this.audioCorrect.muted === false) {
            await this.audioCorrect.pause();
            this.audioCorrect.currentTime = 0;
        }
        if (this.audioSwipe.muted === false) {
            await this.audioSwipe.pause();
            this.audioSwipe.currentTime = 0;
        }
        if (this.audioWrong.muted === false) {
            await this.audioWrong.pause();
            this.audioWrong.currentTime = 0;
        }
        if(this.audioCorrect.muted === false || this.audioWrong.muted===false || this.audioSwipe === false) {
            switch (type) {
                case "correct":
                    await this.audioCorrect.play();
                    break;
                case "wrong":
                    await this.audioWrong.play();
                    break;
                case "click":
                    await this.audioSwipe.play();
                    break;
            }
        }
    }

    startGrading = async (testId) => {
        await REST.getWordMark2Session(testId).then(async (res) => {
            let wmSession = res.body;
            console.log('res.body');
            console.log(res.body);

            if (wmSession) {
                this.setState({
                    storyPrompt1:wmSession.storyPrompt1,
                    storyPrompt2:wmSession.storyPrompt2,
                    sessionData: {
                        gradingData: wmSession.gradingData
                    },
                    studentResponse: wmSession.studentResponse,
                    noteContent: wmSession.note,
                    spelling: wmSession.spelling ? wmSession.spelling : []
                }, () => {
                    this.initializeData(wmSession.gradingData).then(() => {
                        this.checkSpelling();
                    });
                });
            } else {
                this.setState({
                    modalDialog: true,
                    responseContent:'An Invalid Assessment ID has been provided.'

                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }

        }).catch(error => {
            console.log(error)
        });
    };

    async highlightRight(i){
        this.state.wordIndex = i;
        if(this.state.paragraphs[i-1]) {
            this.state.paragraphs[i - 1].highlighted = false;
        }
        if(this.state.paragraphs[i+1]) {
            this.state.paragraphs[i + 1].highlighted = true;
        }
        if(i === this.state.paragraphs.length - 1){
            this.state.paragraphs[i].highlighted = false;
        }
        await this.showCurrentMark(i, false);
        if(this.state.paragraphs[i+1]) {
            await this.showCurrentMark(i + 1, true);
        }
        await this.forceUpdate();
    }

    async highlightLeft(i) {
        this.state.wordIndex = i;
        if (i === this.state.paragraphs.length - 1) {
            this.state.paragraphs[i].highlighted = true;
        }
        if (this.state.paragraphs[i - 1]) {
            this.state.wordIndex = i - 1;
            this.state.paragraphs[i - 1].highlighted = true;
        }
        if (this.state.paragraphs[i + 1]) {
            this.state.paragraphs[i + 1].highlighted = false;
        }
        console.log('mark i');
        console.log(i);
        await this.showCurrentMark(i, true);
        if (this.state.paragraphs[i + 1]) {
            await this.showCurrentMark(i + 1, false);
        }
        await this.forceUpdate();
    }

    // Event handler for keypress events
    keypress = async (e) => {
        let wordIndex = this.state.wordIndex;
        let img = this.state.paragraphs[wordIndex];

        if (e.which === 38) {
            // up arrow
            // console.log("up arrow");
            e.preventDefault();
            if(wordIndex < this.state.paragraphs.length){
                if(img.alt === undefined || img.alt===""){
                    await this.correctTickMark(wordIndex, false);
                }
                else if (img.alt === "wrong"){
                    await this.removeMark(wordIndex);
                    await this.correctTickMark(wordIndex,false);
                }
                await this.highlightRight(wordIndex);
                wordIndex += 1;
                await this.playSound("correct");
            }
        }

        else if (e.which === 40) {
            // down arrow
            // console.log("down arrow");
            e.preventDefault();
            if(wordIndex < this.state.paragraphs.length){
                if (img.alt === undefined || img.alt===""){
                    await this.wrongTickMark(wordIndex, false);
                }
                else if (img.alt === "correct"){
                    await this.removeMark(wordIndex);
                    await this.wrongTickMark(wordIndex, false);
                }
                await this.highlightRight(wordIndex);
                wordIndex += 1;
                await this.playSound("wrong");
            }
        }

        else if (e.which === 37) {
            // left arrow
            // console.log("left arrow");
            e.preventDefault();
            if(wordIndex > 0){
                wordIndex -= 1;
                await this.highlightLeft(wordIndex);
                await this.playSound("click");
            }
        }

        else if (e.which === 39) {
            // right arrow
            //console.log("right arrow");
            e.preventDefault();
            if(wordIndex < this.state.paragraphs.length){
                await this.highlightRight(wordIndex);
                wordIndex += 1;
                await this.playSound("click");
            }
        }

        e.stopImmediatePropagation();
        await this.calculateScore();
        await this.setState({
            wordIndex: wordIndex
        });
    };

    handleLogout = () => {
        REST.logout().then((response) => {
            localStorage.removeItem('token');
            localStorage.clear();
            this.props.history.push("/login");
        }, (error) => {
            console.log('Error', error);
            localStorage.removeItem('token');
            localStorage.clear();
            this.props.history.push("/login");
        });
    };

    async deleteScore(){
            await REST.deleteWordMark2Score(this.state.testId).then(res => {
                this.props.history.goBack();
            });
    }

    deleteScoreConfirm = (confirm) =>{
        if(confirm) {
            this.deleteScore();
        }
        this.setState({
            modalDialogDelete:false,
        });
    }

    handleTakeANote(){
        console.log("take a note");
        this.setState({
            modalDialogNote:true,
        });
    }

    handleNoteContentChange(event) {
        this.setState({ noteContent: event.target.value });
        event.preventDefault();
    }

    saveNote(){
        REST.updateWordMark2Note({testId:this.state.testId, note:this.state.noteContent});
        this.setState({
            modalDialogNote:false,
        });
    }

    deleteNote(){
        this.setState({noteContent:''});
        REST.updateWordMark2Note({testId:this.state.testId, note:''});
    }

    handleNoteClose(){
        this.setState({
            modalDialogNote:false,
        });
    }

    handleStudentClick = (student, classId) => {
        this.props.updateStudent(student);
        this.props.history.push('/teacher/student');
    };

    async handleSurveyBack(){
    }

    render() {

        let paragraphs = this.state.paragraphs.map((paragraph, i) => {

            let spellCheck =  paragraph.spellCheck ? " spellcheck ":"";
            let highLightSelect = paragraph.highlighted ? " highlightSelect" : "";
            return <p key={i}
                      className={spellCheck + highLightSelect}
                      onClick={(e) => this.mouseClick(i,e)}>
                <img hidden={paragraph.alt === ""} style={{left:"-5px"}} src={paragraph.src} alt={paragraph.alt}/>
                {paragraph.word}
            </p>;
        });

        return (

            <div className={"container-fluid bgGrey"} style={{paddingLeft:0,paddingRight:0}}>

                <div className={"container"}>


                    <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                    <DialogBox surveyModal role={'teacher'} app={'WMGrading'} userId={this.props.user.id} active={true} surveyBack={this.handleSurveyBack}/>
                    <DeleteDialogBox
                        confirmDelete={this.deleteScoreConfirm}
                        modalOpen={this.state.modalDialogDelete}
                        sectionContent={this.state.responseContent}
                        closeClick={(active)=>{this.setState({modalDialog: active});}} />
                    <Modal id="dialogBox" show={this.state.modalDialogNote}>
                        <div className="modal-content">
                            <div className={"row modal-body"}>
                                {/*<span style={{cursor:"pointer"}} onClick={this.closeModal}><img style={{width:50,marginTop:25,float:'right'}} src={closeModalIcon} /></span>*/}
                                <div className="section">
                                    <h1 style={{paddingTop:0, marginTop:-10,marginBottom:15}}>Make a Note</h1>
                                    <textarea
                                        style={{width:500}}
                                        onChange={this.handleNoteContentChange}
                                        value={this.state.noteContent}
                                        placeholder={"please enter your note here"}
                                    ></textarea>
                                </div>
                                <div className="section" style={{marginTop:-40}}>
                                    <div className={"col-md-4"}>
                                        <a style={{float:'left'}} onClick={this.deleteNote} className="handBtn">
                                            <span>Delete</span>
                                        </a>
                                    </div>
                                    <div className={"col-md-4"}>
                                        <a style={{float:'left'}} onClick={this.saveNote} className="handBtn">
                                            <span>Close</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>
                    <div className={"center-block"} style={{maxWidth:'100%', marginTop:10}}>
                        <div className={"col-sm-4"}><h1><img src={logo_wordmark2} alt={"Word Mark"} style={{position:'relative',top:-5,width:45,borderRadius:'25%',border:'1px dashed #000'}}/> {this.props.lastStudent.user.firstname} {this.props.lastStudent.user.lastname}</h1></div>
                        {/*<div className={"col-md-6 noPaddingLR"} style={{textAlign:'right',fontSize:18,fontFamily:'Neucha',letterSpacing:'1px',height:42,position:'relative',top:10}}>It took 0 minutes to complete this task</div>*/}
                        <div className={"col-sm-8"}>
                            <div className={"navbar"}> <ReportBugForm {...this.props} /><DropDownNotifications studentClick={this.handleStudentClick} {...this.props} /></div>
                        </div>
                        <div className="col-md-12 noPaddingLR">
                            <hr/>
                        </div>
                    </div>
                </div>
                <div className={"container"} style={{position:'relative', minHeight:'calc(100vh - 88px)', height:'100%'}}>
                    <div  style={{textAlign:'center', marginTop:0,width:1000}}>
                        <div className="row" style={{fontFamily:'Open Sans', fontSize:'1.50em',fontWeight:'bold',textTransform: 'uppercase'}}>
                            <div >"{this.state.storyPrompt1}" And "{this.state.storyPrompt2}"</div>
                        </div>
                    </div>
                    <div className={"center-block"} style={{maxWidth:'100%'}}>
            <div id="appContainer" className={"col-md-12 ksGradingContainer newGradingClass"} style={{backgroundColor:'#FFF',backgroundImage:'initial'}}>
                {/*<header>{this.state.storyStarter.storyStarter}</header>*/}
                <div id="whitebox" className={"newGradingClass"}>
                    <div id="data" className={"col-md-12 newGradingClass"} style={{overflowY:'auto',maxHeight:350}}>
                        {paragraphs}
                    </div>

                    <div id="options" className={"newGradingClass col-md-12"} style={{marginBottom:30}}>
                        <div className={"col-md-12 bgGrey"} style={{padding:15}}>
                        <table style={{width:'100%'}}>
                            <tbody>
                            <tr>

                                <th>
                                    <img alt="correct" src={require("./KSGrading/style/images_WordMark/correct.png")} style={{position:'relative',top:-25,left:50}}/>
                                    <div className="fontSizeCalculationGrading calculationLabelPosition">Correct</div>
                                    <div id="correct" className="backgroundGradeCountBox">{this.state.correct}</div>
                                </th>
                                <th>
                                    <img alt="incorrect" src={require("../assets/images/incorrect.png")} style={{position:'relative',top:-25,left:60}}/>
                                    <div className="fontSizeCalculationGrading calculationLabelPosition">Incorrect</div>
                                    <div id="" className={"backgroundGradeCountBox"}>{this.state.incorrect}</div>
                                </th>
                                <th>
                                    <div className="fontSizeCalculationGrading calculationLabelPosition">Total Words</div>
                                    <div id="" className={"backgroundGradeCountBox"}>{this.state.totalWords}</div>
                                </th>
                                <th>
                                    <div className="fontSizeCalculationGrading calculationLabelPosition">Score</div>
                                    <div id="score" className="backgroundGradeCountBox">{this.state.score}</div>
                                </th>
                                <th>
                                    <div id="spelling" className="fontSizeCalculationGrading" style={{float:'right'}}><span style={{borderBottom:'2px solid #fc0',position:'relative',top:3}}>Possible Spelling Error</span></div>
                                </th>

                                <th><input hidden={true} onClick={this.fillWithChecks} type="image" id="auto_correct"
                                           src={require("./KSGrading/style/images_VideoPlayer/autoCorrect_off.png")}/></th>
                            </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>

                </div>

                <audio src={"/sounds/correct.mp3"} ref={audio=>this.audioCorrect = audio}/>
                <audio src={"/sounds/correct.mp3"} ref={audio=>this.audioWrong = audio}/>
                <audio src={"/sounds/swipe2.mp3"} ref={audio=>this.audioSwipe = audio}/>
            </div>
                        <div className={"col-md-12 noPaddingLR"} style={{marginTop:30}}>
                            <div className={"col-lg-4 col-xs-3 col-md-3 noPaddingLR"}>
                                <a onClick={async ()=>{
                                    await this.setState({
                                        analytics: {
                                            type: TRACKING.WM_SCORE_EXIT,
                                            metadata: {testId: this.state.testId},
                                        }
                                    }); this.handleAnalytics(); this.props.history.push('../student')}} className="handBtn">
                                    <span>Exit</span>
                                </a>
                            </div>
                            <div className={"col-lg-8 col-xs-9 col-md-9 noPaddingLR"} style={{textAlign:'right'}}>
                                <a onClick={this.handleNextTask} className="handBtn" style={{ display: this.state.handleNext ? 'inline-block': 'none'}}><span>Next Task</span></a>
                                <a onClick={this.handleTakeANote} className="handBtn" ><span>Make a Note</span></a>
                                <a onClick={this.submitWordMark2SessionGrade} className="handBtn">
                                    <span>Save</span>
                                </a>
                                <a onClick={this.clearCounters} className="handBtn">
                                    <span>Reset Grading</span>
                                </a>
                                <a onClick={() => {this.setState({modalDialogDelete:true,responseContent:'ARE YOU SURE YOU WANT TO DELETE THIS TASK?'})}} className="handBtn" style={{marginRight:0}}>
                                    <span>Delete</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
const actionToProps = dispatch => {
    return {
        updateStudent: async(student) => await dispatch(updateStudent(student))
    };
};
const mapStateToProps = state => ({
    lastStudent: state.teacherReducer.student,
});
export default connect(mapStateToProps,actionToProps)(withRouter(WordMark2Grading));


// WEBPACK FOOTER //
// ./src/TeachersComponent/WordMark2Grading.js